import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AlertBanner } from './AlertBanner';
import { EssentialMetrics } from './EssentialMetrics';
import { ActivityFeed } from './ActivityFeed';
import { ProductGrid } from './ProductGrid';
export function Dashboard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  return <div className="flex min-h-screen bg-gray-50" data-id="element-14">
      <Sidebar data-id="element-15" />
      <div className="flex-1 pl-64" data-id="element-16">
        <Header title="Dashboard" subtitle="Monitor your products, claims, and supplier compliance" data-id="element-17" />
        <main className="p-8" data-id="element-18">
          <AlertBanner data-id="element-19" />
          <EssentialMetrics data-id="element-20" />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6" data-id="element-21">
            <div className="lg:col-span-2" data-id="element-22">
              <ProductGrid searchQuery={searchQuery} filterStatus={filterStatus} data-id="element-23" />
            </div>
            <div className="lg:col-span-1" data-id="element-24">
              <ActivityFeed data-id="element-25" />
            </div>
          </div>
        </main>
      </div>
    </div>;
}